import { StandardEvents } from '@shopify/events';

class BinderCardFacts extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.revision = 0;
    this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, event => {
      if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
      const revision = ++this.revision;
      event.promise?.then(({ detail }) => {
        if (!this.isConnected || revision !== this.revision || !detail?.html) return;
        const replacement = [...detail.html.querySelectorAll('bb-card-facts')].find(facts => facts.dataset.factsSection === this.dataset.factsSection && facts.dataset.factsBlock === this.dataset.factsBlock);
        if (replacement) this.replaceWith(replacement);
      }).catch(() => { /* The product form reports unsuccessful variant selections. */ });
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); this.controller = null; }
}

if (!customElements.get('bb-card-facts')) customElements.define('bb-card-facts', BinderCardFacts);
